var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Button } from '../../shared';
import React, { useState, useContext, useMemo } from 'react';
import { CardFooter } from '../../shared/card/card-footer';
import { LoaderContext } from '../../../shared/utils/loader/loader-wrapper';
import { DefaultLoadingComponent } from '../../../shared/utils/loader/default-loading-component';
import './case-applicants.scss';
export var CaseApplicantsDetailsFooter = function (_a) {
    var clientId = _a.clientId, documentGridRefresh = _a.documentGridRefresh, documentsExist = _a.documentsExist, expanded = _a.expanded, handleExpand = _a.handleExpand, showUploadModal = _a.showUploadModal;
    var data = useContext(LoaderContext);
    var isLoading = useMemo(function () { return data.isLoading; }, [data.isLoading]);
    var _b = useState(false), showAddClient = _b[0], toggleShowAddClient = _b[1];
    var _c = useState(), modalVisible = _c[0], setModalVisible = _c[1];
    var _d = useState(clientId), customerIdForUpload = _d[0], setCustomerIdForUpload = _d[1];
    var reloadDocumentGrid = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, documentGridRefresh()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var hideModal = function () {
        setModalVisible(false);
    };
    return (React.createElement(CardFooter, null,
        React.createElement("footer", { className: "s-card-client__detail ".concat(documentsExist > 3 ? '' : 's-card-client__detail-partial') },
            documentsExist > 3 && (React.createElement("button", { onClick: handleExpand, className: 's-card-client__detail__button notes__text u-fs-2' },
                React.createElement("b", null, expanded ? 'See less' : 'See more'))),
            isLoading ? (React.createElement(DefaultLoadingComponent, { height: '2rem', width: '10rem', style: { flex: 'none', marginRight: '0' } })) : (React.createElement(Button, { type: "button", variant: "secondary", icon: showAddClient ? 'close' : 'plus', iconPosition: "left", dataValue: clientId, onClick: showUploadModal, size: "small" }, showAddClient ? 'Close' : 'Add document')))));
};
